module.exports = __webpack_public_path__ + "img/1880481.jpg";